module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/core-js/modules/_function-to-string.js
// module id = c5pO
// module chunks = 0